/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 22.10.17.
 */

import {NotImplementedException} from "../../Exceptions";

/**
 * Helpers base class. Actual helpers should implement apply() method.
 */
class BaseHelper {
    /**
     * Create helper object.
     * @param {Object} options Options detailing the helper configuration. See the documentation of the helpers
     */
    constructor(options) {
        /**
         *
         * @type {Object}
         */
        this.options = options;
        this.errors = null;
    }

    /**
     * Apply change the data
     * @abstract
     * @param {string} action Action to perform to the data. One of: "insert", "update", "delete".
     * @param {Object} oldValue Old value
     * @param {Object} newValue New value
     * @param {Schema} schema Schema object for this data
     * @returns {Object} Returns changed data. If there were errors then resulted value is null and method
     * isError() returns true. NB! It is possible, that returned value is null and there are no errors! This is normal -
     * this means that assigned value should be null.
     */
    apply(action, oldValue, newValue, schema) {
        throw new NotImplementedException();
    }

    /**
     * Returns true if apply() fails.
     * @returns {boolean}
     */
    isError() {
        return this.errors !== null;
    }

    /**
     * Return collected errors from apply() execution. If there are no errors then returns null.
     * @returns {?String[]} Returned value is array of error messages.
     */
    getErrors() {
        return this.errors;
    }

}

export default BaseHelper;
